// POS local cache — persists products/categories/settings/payment-methods in localStorage
// so the POS loads instantly on next visit and works offline.
//
// IMPORTANT: cache keys are namespaced PER TENANT (decoded from the JWT). Without this,
// switching accounts on the same browser served the previous account's payment methods /
// products, causing "Payment method not found" on checkout (the cached methodId belongs to
// another tenant). Each account now keeps its own cache.

const tenantFromToken = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return 'anon';
    const payload = JSON.parse(
      atob(String(token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    return payload.tenant || 'anon';
  } catch {
    return 'anon';
  }
};

const makeCache = (base) => {
  const keyFor = () => `${base}_${tenantFromToken()}`;
  return {
    save: (data) => {
      try { localStorage.setItem(keyFor(), JSON.stringify(data)); } catch {}
    },
    // For use as React Query initialData — returns undefined if nothing cached
    // (undefined = React Query fetches fresh; [] would mark query as "done" with empty data)
    initialData: () => {
      try {
        const raw = localStorage.getItem(keyFor());
        if (!raw) return undefined;
        const d = JSON.parse(raw);
        if (Array.isArray(d)) return d.length ? d : undefined;
        return d || undefined;
      } catch { return undefined; }
    },
  };
};

export const posCache = {
  products:       makeCache('mmm_pos_products_v2'),
  categories:     makeCache('mmm_pos_categories_v1'),
  paymentMethods: makeCache('mmm_pos_methods_v1'),
  settings:       makeCache('mmm_pos_settings_v1'),
  accounts:       makeCache('mmm_pos_accounts_v1'),
};

// One-time cleanup of the old un-namespaced keys (they could leak between accounts).
try {
  ['mmm_pos_products_v1', 'mmm_pos_products_v2', 'mmm_pos_categories_v1', 'mmm_pos_methods_v1',
   'mmm_pos_settings_v1', 'mmm_pos_accounts_v1'].forEach((k) => {
    if (localStorage.getItem(k)) localStorage.removeItem(k);
  });
} catch {}
